import React from "react";
import { cn } from "@gettactic/helpers";

export interface WizardReviewColorSwatchProps {
  color: string;
  label: string;
  className?: string;
}

/** A colour chip and its label. */
export const WizardReviewColorSwatch: React.FC<WizardReviewColorSwatchProps> = ({
  color,
  label,
  className
}) => (
  <div className={cn("flex items-center gap-2", className)}>
    <div
      className="size-5 rounded border border-neutral-200"
      style={{ backgroundColor: color }}
    />
    <span className="text-xs text-content">{label}</span>
  </div>
);

export interface WizardReviewColorSwatchGroupProps {
  colors: Array<{ color: string; label: string }>;
  className?: string;
}

/** The theme colours of a review step; renders nothing without colours. */
export const WizardReviewColorSwatchGroup: React.FC<WizardReviewColorSwatchGroupProps> = ({
  colors,
  className
}) => {
  const validColors = colors.filter((c) => c.color);

  if (validColors.length === 0) return null;

  return (
    <div className={className}>
      <span className="text-sm text-content">Theme Colors</span>
      <div className="mt-2 flex gap-3">
        {validColors.map((c) => (
          <WizardReviewColorSwatch key={c.label} color={c.color} label={c.label} />
        ))}
      </div>
    </div>
  );
};
